import React from "react";
import { createRoot } from "react-dom/client";
import RoutesProviders from "./RoutesProviders";

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<RoutesProviders />);
